import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "tooltiptext max-w-500 mtop-30 font-s"
}

import { ItemTag } from '@/models/share.model';
import { StyleValue } from 'vue';
import SharedService from "@/services/SharedService";


export default /*@__PURE__*/_defineComponent({
  __name: 'esTagList',
  props: {
    items: {},
    style: {},
    disabled: { type: Boolean, default: false },
    deleteOption: { type: Boolean, default: false },
    displayTooltip: { type: Boolean, default: false },
    filterOpened: { type: Boolean, default: false }
  },
  emits: ['tagClick'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;
const tagClick = (item: ItemTag) => {
    if (!props.disabled) {
        emits('tagClick', item);
    }
}

const getClass = (item: ItemTag) => {
    let cssClass = "es-tag item-center";

    if (props.disabled) {
        cssClass += ' es-tag-disabled';
    }

    if (item.selected) {
        cssClass += ' es-tag-selected';
    } else {
        cssClass += ' es-tag-unselected';
    }

    if (props.style) {
        cssClass = cssClass + " " + props.style;
    }

    if (props.displayTooltip) {
        cssClass = cssClass + " " + "tooltip";
    }

    return cssClass;
}

const getStyleTag = (item: ItemTag, isDisabled: boolean) => {
    let cssStyle = {} as StyleValue;
    if (item.itemTagColors && !isDisabled) {
        cssStyle = {backgroundColor: item.itemTagColors.disabledBackgroundColor};
        if(item.selected)
            cssStyle = {backgroundColor: item.itemTagColors.backgroundColor}
    }
    return cssStyle;
}

const getStyleText = (item: ItemTag, isDisabled: boolean) => {
    let cssStyle = {} as StyleValue;
    if (item.itemTagColors && !isDisabled) {
        cssStyle = {color: item.itemTagColors.disabledTextColor};
        if(item.selected)
            cssStyle = {color: item.itemTagColors.textColor}
    }
    return cssStyle;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: "max-w-9vw"
    }, [
      (!_ctx.filterOpened || item.opened)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle(getStyleTag(item, props.disabled)),
            class: _normalizeClass(getClass(item))
          }, [
            _createElementVNode("span", {
              style: _normalizeStyle(getStyleText(item, props.disabled)),
              onClick: ($event: any) => (tagClick(item)),
              class: _normalizeClass(["font-size-14 ellipsis", item.selected ? 'es-item-selected' : 'es-item-unselected'])
            }, _toDisplayString(item.label), 15, _hoisted_1),
            (_ctx.deleteOption)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _unref(SharedService).getIcon('xmark', false, 'shareIcons')
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
            (_ctx.displayTooltip)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.label), 1))
              : _createCommentVNode("", true)
          ], 6))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}
}

})